import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import messageActions from 'actions/messages/actions';
import MessageBox from 'forms/merchant/message/message-box';
import TopInquiry from './inquiry/top-inquiry';
import Proposal from './inquiry/types/proposal';
import Message from './message';
import MessageAccept from './message-accept';
import MessageSystem from './message-system'

const Conversation = ({ user, match, getMessages, messages, sendMessage, conversation, leadDetail, typings, handleMessageOrProposal, proposalDetail }) => {
  const isAdmin = leadDetail === null
  const requestDate = leadDetail ? leadDetail.schedule_date : ''
  const [sender, setSender] = useState({})
  useEffect(() => {
    getMessages(match.params.id)
  }, [match.params.id])
  const msgMerchant = useRef()
  useEffect(() => {
    msgMerchant.current.scrollTop = msgMerchant.current.scrollHeight
  })
  useEffect(() => {
    if (conversation.members && conversation.members.length) {
      setSender(conversation.members.find(mem => mem.id !== user.id) || {})
    }
  }, [conversation])
  const renderTypings = (users) => {
    let str = ''
    if (users.length) {
      const names = users.map(usr => decodeURIComponent(usr.user_name))
      str += `${names.join(', ')} is typing ...`
    }
    return <>{str}</>
  }

  const renderMessages = (message, user) => {
    const msgSystem = message.type !== 'message'
    const updateAt = moment(message.updated_at).local().format('MMMM DD YYYY, h:mm A')
    const isOdd = message.sender_id !== user.id
    const members = conversation.members || []
    const avatar = isOdd ? members.find(m => m.id !== user.id)?.profile?.avatar : members.find(m => m.id === user.id)?.profile?.avatar
    return msgSystem ? <MessageSystem key={message.id} message={message.body} updateAt={updateAt} type={message.type}/> : <Message
      isOdd={isOdd}
      key={message.id}
      body={message.body}
      avatar={avatar}
      updateAt={updateAt}
      isAdmin={isAdmin}/>
  }
  return (
    <div className="conversation w-9/12 flex h-full">
      <div className={`flex flex-col h-full border-r ${leadDetail ? 'w-8/12' : 'w-full'} shadow`}>
        {sender && sender.name && <TopInquiry
          name={sender.name}
          space={leadDetail ? leadDetail.space_name : ''}
          date={leadDetail ? leadDetail.created_date : ''}
          status={conversation.status}
          isAdmin={isAdmin}/>}
        <div className="h-full flex px-5 overflow-y-auto flex-col justify-start" ref={msgMerchant}>
          {messages && messages.map((message) => {
            return renderMessages(message, user)
          })}
          {!conversation.isAccept && <MessageAccept inquiryId={conversation.inquiry_id} status={conversation.status}/>}
        </div>
        <div className="typing text-xs pl-2 text-gray-600">{renderTypings(typings)}</div>
        <MessageBox
          onSubmit={values => {
            (values.message || (values.attachment && values.attachment.length)) && sendMessage({ ...values, conversationId: match.params.id })
          }}
          form="message-box-form"
          id={conversation.id}
          typingName={user.name}
          typingId={user.id}
          status={conversation.status}
          spaceId={leadDetail ? leadDetail.space_id : null}
          handleMessageOrProposal={handleMessageOrProposal}
          proposalDetail={proposalDetail}
          client={sender}
          inquiryId={conversation.inquiry_id}
          isAdmin={isAdmin} />
      </div>
      {sender && sender.name && leadDetail && <div className="w-4/12">
        <Proposal
          space={{
            title: leadDetail.space_name,
            address: leadDetail.address,
            spaceUrl: leadDetail.space_url,
            image: leadDetail.image
          }}
          type={leadDetail.lead_type}
          name={sender.name}
          requestDate={requestDate}
          email={conversation.status !== 'pending' ? sender.email : ''}
          phone={conversation.status !== 'pending' ? sender.profile?.phone : ''}
          userType={'CLIENT'} />
      </div>}
    </div>
  )
}

Conversation.propTypes = {
  user: PropTypes.object,
  sendMessage: PropTypes.func,
  conversation: PropTypes.object,
  getMessages: PropTypes.func,
  match: PropTypes.object,
  messages: PropTypes.arrayOf(PropTypes.object),
  leadDetail: PropTypes.object,
  typings: PropTypes.array,
  handleMessageOrProposal: PropTypes.func,
  proposalDetail: PropTypes.object
};

const mapStateToProps = ({ messages, auth }, { match }) => ({
  conversation: messages.conversation.list.find(con => Number(con.id) === Number(match.params.id)) || {},
  user: auth.user,
  messages: messages && messages.index.messages,
  leadDetail: messages && messages.index.leadDetail,
  typings: (messages.index.typings || []).filter(typing => typing.typingId !== auth.user.id),
  proposalDetail: messages.index.proposalDetail
});

const mapDispatchToProps = {
  sendMessage: messageActions.sendMessage,
  getMessages: messageActions.getMessages,
};

export default connect(mapStateToProps, mapDispatchToProps)(Conversation);
